import React from 'react';
import PropTypes from 'prop-types';

const AuthContext = React.createContext(null);

export const AuthProvider = ({ userData, children }) => {
  let [user, setUser] = React.useState(userData);
  const [verifiedCustomerId, setVerifiedCustomerIdState] = React.useState(localStorage.getItem('verifiedCustomerId'));

  const setVerifiedCustomerId = (id) => {
    if (id) {
      localStorage.setItem('verifiedCustomerId', id);
    } else {
      localStorage.removeItem('verifiedCustomerId');
    }
    setVerifiedCustomerIdState(id);
  }

  user = typeof user === 'string' ? JSON.parse(user) : user;
  const removeUserAuth = () => {
    setUser(null);
    setVerifiedCustomerId(null);
  };
  return (
    <AuthContext.Provider value={{ user, setUser, removeUserAuth, verifiedCustomerId, setVerifiedCustomerId }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  userData: PropTypes.any,
  children: PropTypes.any,
};

export const useAuth = () => React.useContext(AuthContext);
